















import { Vue, Prop, Component } from "vue-property-decorator"

@Component({})
export default class RecipeProcedure extends Vue {
	@Prop({ required: true }) id!: string;
	@Prop({ required: true }) title!: string;
}
